// src/redux/reducers/callReducer.js

import { INCOMING_CALL, ACCEPT_CALL, END_CALL, SET_CALL_OFFER, CLEAR_CALL_OFFER, SET_ACTIVE_CALL } from "../actions/callActions";

const initialState = {
    incomingCall: null,
    activeCall: false,
    offer: null,

};

export default function callReducer(state = initialState, action) {
    switch (action.type) {
        case INCOMING_CALL:
            return { ...state, incomingCall: action.payload };
        case ACCEPT_CALL:
            return { ...state, activeCall: true };
        case END_CALL:
            return { incomingCall: null, activeCall: false, offer: null };
        case SET_CALL_OFFER:
            return { ...state, offer: action.payload };
        case CLEAR_CALL_OFFER:
            return { ...state, offer: null };
        case SET_ACTIVE_CALL:
            return { ...state, active: action.payload };
       
        default:
            return state;
    }
}
